<template>
   <div class="home">
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in items" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>
    <p align="center">
        <v-chip v-if="nbrSms === 0" outline text-color="red" label color="red" style="font-size:20px; width:100%">
          VOUS N'AVEZ PLUS D'SMS. VOUS NE POUVEZ DONC PAS RECEVOIR D'SMS DE NOTIFICATION. VEUILLEZ RECHARGER VOTRE COMPTE 
        </v-chip>
    </p>

    <!-- RACOURCIS -->
    <el-row :gutter="20">
        <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#fff">
                <div id="userChart" style="width:1400px; height:400px"></div>
              </el-card>
            </div>
            <br/>
        </el-col>
    </el-row>

    <el-row :gutter="20">
        <el-col v-if="droitAcces.last_commande" :span="8">
            <div class="grid-content bg-purple">
              <el-card class="box-card"  style="background:#fff">
                <div class="text item">

                    <v-flex xs3 >
                      <el-col :span="2" >
                        <el-popover
                        ref="popover5"
                        placement="top"
                        width="180"
                        trigger="hover"
                        >
                          <p>Veuillez choisir le format d'impression ?</p>
                          <div style="text-align: right; margin: 0">
                            <el-button type="success" size="mini" @click="imprimeListeCmde('PDF')">PDF</el-button>
                            <el-button type="primary" size="mini" @click="imprimeListeCmde('EXC')">EXCEL</el-button>
                          </div>
                        </el-popover>
                          <div>
                            <el-button v-popover:popover5 type="warning" :disabled="disabledBtnCmd"
                                icon="el-icon-printer" >Imprimer la liste
                            </el-button>
                          </div>
                      </el-col>
                    </v-flex>

                    <p align="center">
                        <v-chip outline text-color="primary" label color="primary" style="font-size:20px; width:100%">
                          LISTE DES 10 DERNIÈRES COMMANDES
                        </v-chip>
                    </p>

                    <el-table ref="multipleTable" :data="listLastCommande" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width:100%">
                        <el-table-column prop="ref" label="Référence" width="100" fixed>
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{scope.row.ref}}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="total" label="Montant" width="230">
                            <template slot-scope="scope">
                                <v-chip outline text-color="primary" label color="primary">
                                    {{ scope.row.total }} FCFA<v-icon right></v-icon>
                                </v-chip>
                            </template>
                        </el-table-column>
                        <el-table-column label="Etat" width="280">
                            <template slot-scope="scope">
                                <v-chip outline text-color="orange" label color="orange" v-if="scope.row.factureValide === 0">
                                    EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="green" label color="green" v-if="scope.row.factureValide === 1">
                                    VALIDE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="red" label color="red" v-if="scope.row.factureValide === 2">
                                    REJETE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="red" label color="red" v-if="scope.row.etat === false">
                                    NON LIVRE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="green" label color="green" v-if="scope.row.etat == true">
                                    LIVRE EN TOTALITE<v-icon right></v-icon>
                                </v-chip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
              </el-card>
            </div>
        </el-col>

        <el-col v-if="droitAcces.last_facture" :span="8">
            <div class="grid-content bg-purple">
              <el-card class="box-card"  style="background:#fff">
                <div class="text item">

                    <v-flex xs3 >
                      <el-col :span="2" >
                        <el-popover
                        ref="popover5"
                        placement="top"
                        width="180"
                        trigger="hover"
                        >
                          <p>Veuillez choisir le format d'impression ?</p>
                          <div style="text-align: right; margin: 0">
                            <el-button type="success" size="mini" @click="imprimeListeFact('PDF')">PDF</el-button>
                            <el-button type="primary" size="mini" @click="imprimeListeFact('EXC')">EXCEL</el-button>
                          </div>
                        </el-popover>
                          <div>
                            <el-button v-popover:popover5 type="warning" :disabled="disabledBtnFact"
                                icon="el-icon-printer" >Imprimer la liste
                            </el-button>
                          </div>
                      </el-col>
                    </v-flex>

                    <p align="center">
                        <v-chip outline text-color="primary" label color="primary" style="font-size:20px; width:100%">
                          LISTE DES 10 DERNIÈRES FACTURES
                        </v-chip>
                    </p>

                    <el-table ref="multipleTable" :data="listLastFacture" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width:100%">
                        <el-table-column prop="ref" label="Référence" width="100" fixed>
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{scope.row.ref}}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="total" label="Montant" width="230">
                            <template slot-scope="scope">
                                <v-chip outline text-color="primary" label color="primary">
                                    {{ scope.row.total }} FCFA<v-icon right></v-icon>
                                </v-chip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="etatFact" label="Etat" width="280">
                            <template slot-scope="scope">
                                <v-chip outline text-color="orange" label color="orange" v-if="scope.row.etatFact === 0">
                                    EN ATENTE DE VALIDATION<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="green" label color="green" v-if="scope.row.etatFact === 1">
                                    VALIDE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="red" label color="red" v-if="scope.row.etatFact === 2">
                                    REJETE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip text-color="white" label color="red" v-if="scope.row.etatReglFact === false">
                                    IMPAYE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip text-color="white" label color="green" v-if="scope.row.etatReglFact === true">
                                    PAYE<v-icon right></v-icon>
                                </v-chip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
              </el-card>
            </div>
        </el-col>
    
        <el-col v-if="droitAcces.last_livraison" :span="8" >
            <div class="grid-content bg-purple">
                <el-card class="box-card" style="background:#fff">

                    <v-flex xs3 >
                      <el-col :span="2" >
                        <el-popover
                        ref="popover5"
                        placement="top"
                        width="180"
                        trigger="hover"
                        >
                          <p>Veuillez choisir le format d'impression ?</p>
                          <div style="text-align: right; margin: 0">
                            <el-button type="success" size="mini" @click="imprimeListeLiv('PDF')">PDF</el-button>
                            <el-button type="primary" size="mini" @click="imprimeListeLiv('EXC')">EXCEL</el-button>
                          </div>
                        </el-popover>
                          <div>
                            <el-button v-popover:popover5 type="warning" :disabled="disabledBtnLiv"
                                icon="el-icon-printer" >Imprimer la liste
                            </el-button>
                          </div>
                      </el-col>
                    </v-flex>

                    <p align="center">
                        <v-chip outline text-color="primary" label color="primary" style="font-size:20px; width:100%">
                          LISTE DES 10 DERNIÈRES LIVRAISONS
                        </v-chip>
                    </p>

                    <el-table ref="multipleTable" :data="listLastLivraison" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width:100%">
                        <el-table-column prop="ref" label="Référence" width="100" fixed>
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{scope.row.ref}}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column prop="commande" label="Commande" width="230">
                            <template slot-scope="scope">
                                <v-chip outline text-color="primary" label color="primary">
                                    {{ scope.row.commande }} {{ scope.row.libelle }} <v-icon right></v-icon>
                                </v-chip>
                                <v-chip v-if="scope.row.etat === false" outline text-color="orange" label color="orange">
                                    PARTIELLEMENT LIVRE <v-icon right></v-icon>
                                </v-chip>
                                <v-chip v-if="scope.row.etat === true" outline text-color="green" label color="green">
                                    TOTALEMENT LIVRE <v-icon right></v-icon>
                                </v-chip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="date" label="Date" width="280">
                            <template slot-scope="scope">
                                <v-chip outline text-color="primary" label color="primary">
                                    {{ scope.row.date }}
                                </v-chip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </div>
            <br/>
        </el-col>
    </el-row>

    <el-row :gutter="20">
        <el-col v-if="droitAcces.last_paiement" :span="12">
            <div class="grid-content bg-purple">
                <el-card class="box-card" style="background:#fff">
                    <div class="text item">

                        <v-flex xs3 >
                          <el-col :span="2" >
                            <el-popover
                            ref="popover5"
                            placement="top"
                            width="180"
                            trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button type="success" size="mini" @click="imprimeListePaie('PDF')">PDF</el-button>
                                <el-button type="primary" size="mini" @click="imprimeListePaie('EXC')">EXCEL</el-button>
                              </div>
                            </el-popover>
                              <div>
                                <el-button v-popover:popover5 type="warning" :disabled="disabledBtnPaie"
                                    icon="el-icon-printer" >Imprimer la liste
                                </el-button>
                              </div>
                          </el-col>
                        </v-flex>

                        <p align="center">
                            <v-chip outline text-color="primary" label color="primary" style="font-size:20px; width:100%">
                              LISTE DES 10 DERNIERS PAIEMENTS
                            </v-chip>
                        </p>

                        <el-table ref="multipleTable" :data="listLastPaiemnet" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width:100%">
                            <el-table-column prop="ref" label="Référence" fixed>
                              <template slot-scope="scope" width="140">
                                <v-chip text-color="white" label color="primary">
                                  {{scope.row.ref}}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="etat" label="Etat">
                                <template slot-scope="scope">
                                    <v-chip v-if="scope.row.etat === false" text-color="white" label color="red">
                                        IMPAYE
                                    </v-chip>
                                    <v-chip v-else text-color="white" label color="green">
                                        PAYE
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="montant" label="Montant" width="200">
                                <template slot-scope="scope">
                                    <v-chip text-color="white" label color="secondary">
                                        {{scope.row.montant}} FCFA
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" label="Date" width="240">
                                <template slot-scope="scope">
                                    <v-chip text-color="white" label color="secondary">
                                        {{scope.row.date}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </div>
        </el-col>
    
        <el-col v-if="droitAcces.retard_paiement" :span="12" >
            <div class="grid-content bg-purple">
                <el-card class="box-card" style="background:#fff">
                    <div class="text item">

                        <v-flex xs3 >
                          <el-col :span="2" >
                            <el-popover
                            ref="popover5"
                            placement="top"
                            width="180"
                            trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div style="text-align: right; margin: 0">
                                <el-button type="success" size="mini" @click="imprimeListeRetard('PDF')">PDF</el-button>
                                <el-button type="primary" size="mini" @click="imprimeListeRetard('EXC')">EXCEL</el-button>
                              </div>
                            </el-popover>
                              <div>
                                <el-button v-popover:popover5 type="warning" :disabled="disabledBtnReta"
                                    icon="el-icon-printer" >Imprimer la liste
                                </el-button>
                              </div>
                          </el-col>
                        </v-flex>

                        <p align="center">
                            <v-chip outline text-color="primary" label color="primary" style="font-size:20px; width:100%">
                              LISTE DES PAIEMENTS EN RETARD
                            </v-chip>
                        </p>

                        <el-table ref="multipleTable" :data="listRetardPaiemnet" :default-sort="{prop: 'id', order: 'descending'}" stripe border height="350" style="width:100%">
                            <el-table-column prop="ref" label="Référence" fixed>
                              <template slot-scope="scope" width="140">
                                <v-chip text-color="white" label color="primary">
                                  {{scope.row.ref}}
                                </v-chip>
                              </template>
                            </el-table-column>
                            <el-table-column prop="concerne" label="Concerne">
                                <template slot-scope="scope">
                                    <v-chip outline text-color="primary" label color="primary">
                                        {{scope.row.concerne}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="etat" label="Etat">
                                <template slot-scope="scope">
                                    <v-chip text-color="white" label color="red">
                                        {{scope.row.etat}}
                                    </v-chip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="fournisseur" label="Fournisseur"></el-table-column>
                            <el-table-column prop="total" label="Montant" width="200">
                                <template slot-scope="scope">
                                    <v-chip text-color="white" label color="secondary">
                                        {{scope.row.total}} FCFA
                                    </v-chip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </div>
            <br/>
        </el-col>
    </el-row> 

  </div>
</template>

<script>
    var echarts = require('echarts/lib/echarts')    
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')    
    require('echarts/lib/chart/funnel')  
    require('echarts/lib/chart/sankey')  
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    export default {
        name: 'home',
        data () {
          return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            items: [
              { path: '/login', text: 'Accueil', disabled: false }
            ],
            listLastCommande: [],
            listLastFacture: [],
            listLastLivraison: [],
            listLastPaiemnet: [],
            listRetardPaiemnet: [],
            listDemandeAnnee: [],
            nbrSms: 0,
            disabledBtnCmd: false,
            disabledBtnFact: false,
            disabledBtnLiv: false,
            disabledBtnPaie: false,
            disabledBtnReta: false,
          }
        },
        methods: {
            loadPage () {
                const loading = this.$loading({
                  lock: true,
                  text: 'Veuillez patientez ...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                })
                setTimeout(() => {
                  loading.close()
                }, 1000)
            },
            loadLastCommande () {
                let url = this.domaine + 'webService/last/commande'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listLastCommande = response.body.commande
                        if (this.listLastCommande === undefined || this.listLastCommande.length == 0) {
                            this.disabledBtnCmd = true
                        } else{
                          this.disabledBtnCmd = false
                        }
                    }
                })
            },
            loadLastFacture () {
                let url = this.domaine + 'webService/last/facture'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listLastFacture = response.body.facture
                        if (this.listLastFacture === undefined || this.listLastFacture.length == 0) {
                            this.disabledBtnFact = true
                        } else{
                          this.disabledBtnFact = false
                        }
                    }
                })
            },
            loadLastLivraison () {
                let url = this.domaine + 'webService/last/livraison'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listLastLivraison = response.body.livraison
                        if (this.listLastLivraison === undefined || this.listLastLivraison.length == 0) {
                            this.disabledBtnLiv = true
                        } else{
                          this.disabledBtnLiv = false
                        }
                    }
                })
            },
            loadLastPaiement () {
                let url = this.domaine + 'webService/last/paiement'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listLastPaiemnet = response.body.paiement
                        if (this.listLastPaiemnet === undefined || this.listLastPaiemnet.length == 0) {
                            this.disabledBtnPaie = true
                        } else{
                          this.disabledBtnPaie = false
                        }
                    }
                })
            },
            loadRetardPaiement () {
                let url = this.domaine + 'webService/retard/paiement'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listRetardPaiemnet = response.body.retard
                        if (this.listRetardPaiemnet === undefined || this.listRetardPaiemnet.length == 0) {
                            this.disabledBtnReta = true
                        } else{
                          this.disabledBtnReta = false
                        }
                    }
                })
            },
            loadStatDemandeAnnee () {
                let url = this.domaine + 'webService/index'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listDemandeAnnee = response.body.demande
                        this.nbrSms = response.body.nbrSms
                        this.statDemandeAnnee()
                    }
                })
            },
            statDemandeAnnee (){
                //optionUser
                var optionDemandeAnnee = {
                    title: {
                        text: 'DEMANDES TRAITE ET NON TRAITE DURANT LES 12 DERNIERS MOIS',
                        subtext: '',
                        left: 'center'
                    },
                    tooltip : {
                        trigger: 'axis',
                        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        data:[]
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            data : []
                        }
                    ],
                    yAxis : [
                        {
                            type : 'value'
                        }
                    ],
                    series : [
                        {
                            name:'Demandes réfusés',
                            type:'bar',
                            data:[]
                        },
                        {
                            name:'Demandes en cours',
                            type:'bar',
                            stack: '',
                            data:[]
                        },
                        {
                            name:'Demandes traité',
                            type:'bar',
                            stack: '',
                            data:[]
                        }
                    ]
                };

                this.listDemandeAnnee.forEach(function(element) {
                  optionDemandeAnnee.xAxis[0].data.push(element.date);
                  optionDemandeAnnee.series[0].data.push(element.traite)
                  optionDemandeAnnee.series[1].data.push(element.nonTraite)
                  optionDemandeAnnee.series[2].data.push(element.refuse)
                })

                let userChart = echarts.init(document.getElementById('userChart'))
                userChart.setOption(optionDemandeAnnee)
            },

            imprimeListeCmde (type) {
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"webService/imprimerPDF/commande/last"
                }else {
                    url = this.domaine+"webService/imprimerEXC/commande/last"
                }
                window.open(url)
            },
            imprimeListeFact (type) {
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"webService/imprimerPDF/facture/last"
                }else {
                    url = this.domaine+"webService/imprimerEXC/facture/last"
                }
                window.open(url)
            },
            imprimeListeLiv (type) {
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"webService/imprimerPDF/livraison/last"
                }else {
                    url = this.domaine+"webService/imprimerEXC/livraison/last"
                }
                window.open(url)
            },
            imprimeListePaie (type) {
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"webService/imprimerPDF/paiement/last"
                }else {
                    url = this.domaine+"webService/imprimerEXC/paiement/last"
                }
                window.open(url)
            },
            imprimeListeRetard (type) {
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"webService/imprimerPDF/paie-retard/last"
                }else {
                    url = this.domaine+"webService/imprimerEXC/paie-retard/last"
                }
                window.open(url)
            },

        },
        mounted () {
            this.loadPage()
            this.loadLastCommande()
            this.loadLastFacture()
            this.loadLastLivraison()
            this.loadLastPaiement()
            this.loadRetardPaiement()
            this.loadStatDemandeAnnee()
        },
        beforeMount: function () {
            if(!this.roleAcces[this.$router.history.current.name]){
                if (this.user.type === 1) {
                    this.$router.push({ name: 'Home' })
                } else if (this.user.type === 2) {
                    this.$router.push({ name: 'Demande' })
                } else if (this.user.type === 3) {
                    this.$router.push({ name: 'Fournisseur' })
                }                
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue